<template>
  <div class='InitInputImg' :style="{ width: computedWidth, marginLeft: computedMarginLeft }">
    <div class="label">{{ label }} {{ required ? '*' : '' }}</div>
    <div class="cont-btn">
      <div class="cont-img" :class="{ error: error }" :style="{ height: height, width: widthImg }">
        <span v-if="!value.length">sem imagem</span>
        <img :src="value" v-if="value.length"/>
      </div>
      <button @click="$refs.in.click()">
        <UploadIcon/>
        <Label>Enviar</Label>
      </button>
    </div>
    <div class="desc">{{ desc }}</div>
    <input ref="in" v-show="false" type="file" @change="inFile"/>
  </div>
</template>

<script>
import UploadIcon from './UploadIcon'
import compressImage from '@/mixins/compressImage'
export default {
  name: 'InitInputImg',
  components: { UploadIcon },
  mixins: [compressImage],
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    required: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '100%'
    },
    widthImg: {
      type: String,
      default: '79%'
    },
    height: {
      type: String,
      default: '50px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    desc: {
      type: String,
      default: 'Recomendações'
    },
    value: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedWidth () {
      return window.innerWidth < 500 ? '100%' : this.width
    },
    computedMarginLeft () {
      return window.innerWidth < 500 ? '0%' : this.marginLeft
    }
  },
  methods: {
    inFile (e) {
      for (let key in e.target.files) {
        if (key !== 'length' && key !== 'item') {
          this.getBase64(e.target.files[key])
        }
      }
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = async () => {
        this.$emit('returnValue', await this.compressImage(reader.result))
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    }
  }
}
</script>

<style scoped>
.InitInputImg {
  width: 100%;
  text-align: left;
}

.label {
  font-size: 12px;
  font-weight: bold;
}

.cont-btn {
  display: flex;
  align-items: center;
}

.cont-img {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  width: 79%;
  border-radius: 12px;
  border: thin solid #CCCCCC;
  background-color: #EEEEEE;
  text-align: justify;
  overflow: hidden;
}

img {
  width: 100%;
  height: 100%;
}

button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: max-content;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  box-shadow: 1px 1px 2px 0.5px #CCCCCC;
  background-color: #FFFFFF;
  cursor: pointer;
  padding: 4px;
  margin-left: 10px;
}

.desc {
  font-size: 10px;
}

.error {
  border: thin solid red;
}
</style>
